// Self-contained on/off switch. Bootstrap's `form-switch` renders badly under
// this theme's CSS (the knob disappears and the label crowds the track), so
// this draws the track and knob itself.
// Track / knob sizes. The knob's translate equals track width − knob − 2×inset.
const SIZES = {
    md: { track: 'tw-w-9 tw-h-5', knob: 'tw-w-4 tw-h-4', on: 'peer-checked:tw-translate-x-4' },
    sm: { track: 'tw-w-7 tw-h-4', knob: 'tw-w-3 tw-h-3', on: 'peer-checked:tw-translate-x-3' },
};

const ToggleSwitch = ({ id, checked, onChange, label, description, disabled = false, size = 'md', className = '' }) => {
    const s = SIZES[size] || SIZES.md;
    return (
    <label
        htmlFor={id}
        className={`tw-inline-flex tw-items-start tw-gap-2.5 tw-mb-0 tw-select-none ${disabled ? 'tw-opacity-50 tw-cursor-not-allowed' : 'tw-cursor-pointer'} ${className}`}
    >
        {/* Nudge down to line up with label text; bare switches stay centred */}
        <span className={`tw-relative tw-inline-flex tw-flex-shrink-0 ${label || description ? 'tw-mt-0.5' : ''}`}>
            <input
                id={id}
                type="checkbox"
                role="switch"
                className="tw-sr-only tw-peer"
                checked={!!checked}
                disabled={disabled}
                onChange={(e) => onChange?.(e.target.checked)}
            />
            <span className={`tw-block ${s.track} tw-rounded-full tw-bg-gray-300 tw-transition-colors peer-checked:tw-bg-emerald-500 peer-focus-visible:tw-ring-2 peer-focus-visible:tw-ring-offset-1 peer-focus-visible:tw-ring-emerald-400`} />
            <span className={`tw-absolute tw-top-0.5 tw-left-0.5 ${s.knob} tw-rounded-full tw-bg-white tw-shadow tw-transition-transform ${s.on}`} />
        </span>
        {(label || description) && (
            <span className="tw-leading-tight">
                {label && <span className="tw-block tw-text-xs tw-font-medium tw-text-gray-700">{label}</span>}
                {description && <span className="tw-block tw-text-[11px] tw-text-gray-500 tw-mt-0.5">{description}</span>}
            </span>
        )}
    </label>
    );
};

export default ToggleSwitch;
